module.exports = "M2,21L23,12L2,3V10L17,12L2,14V21Z"


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-design-icons-svg/paths/send.json
// module id = 414
// module chunks = 0